import { ScheduleAPI } from '../../../api/datamanager/ScheduleAPI';

export class SchedulesDraftCommand {    
    get(edition, providerId, successCallback, errorCallback) {
        const apiResult = ScheduleAPI.listDraft(edition.draftPlanning, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((_) => {
            if (undefined !== errorCallback) {
                errorCallback("[Rascunho] Ocorreu um erro a ler os horários");
            }
        });
    }

    count(draftPlanningEdition, providerId, successCallback, errorCallback) {
        const apiResult = ScheduleAPI.countDraft(draftPlanningEdition, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(edition, schedule, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(undefined !== schedule.setOfDayTypes && null !== schedule.setOfDayTypes) {
            schedule.setOfDayTypesId = schedule.setOfDayTypes.id;
            schedule.setOfDayTypes = undefined;
        }

        if(undefined === schedule.id || 0 === schedule.id) {
            apiResult = ScheduleAPI.createDraft(edition.draftPlanning, schedule);
            successMessage = "[Rascunho] Horário criado com sucesso";
        }
        else {
            apiResult = ScheduleAPI.updateDraft(edition.draftPlanning, schedule.id, schedule);
            successMessage = "[Rascunho] Horário editado com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch(_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(draftPlanning, scheduleId, successCallback, errorCallback) {
        const apiResult = ScheduleAPI.deleteDraft(draftPlanning, scheduleId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Horário eliminado com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/SchedulesDraftCommand.js